import React from "react";
import { useMutation } from "@tanstack/react-query";
import { submitPut } from "../../../../../../enums/queryFunction/Submit";
import { SnackbarContext } from "../../../../../../contexts/Snackbar";

export default function useUpdateWarehouseItem(clinicId) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  // Ref, not state -- callers read this synchronously right after `await
  // update(...)` resolves, before a state update would have re-rendered.
  const lastError = React.useRef(null);

  const mutation = useMutation({
    mutationFn: ({ itemId, data }) =>
      submitPut(`/warehouse/clinic/${clinicId}/items/${itemId}`, data),
  });

  async function update(itemId, data) {
    lastError.current = null;
    try {
      const response = await mutation.mutateAsync({ itemId, data });
      handleSnackbar("success", "success");
      return response?.data ?? null;
    } catch (err) {
      lastError.current = err;
      handleSnackbar(err, "error");
      return null;
    }
  }

  return { update, isUpdating: mutation.isPending, getLastError: () => lastError.current };
}
